/* Spare Skins: shade finder + waitlist tagging. Pages: /pages/skin, /pages/shade-finder. */
(function () {
  var C = ['#EFD2C4', '#DDB09E', '#BE8B76', '#8E5B4B', '#56332C'];
  var W = ['#F0D5B8', '#DEB189', '#BD875B', '#8F5C37', '#55341F'];
  var CN = ['Linen', 'Stone', 'Clay', 'Cedar', 'Walnut'];
  var WN = ['Sand', 'Wheat', 'Oak', 'Amber', 'Espresso'];
  var DEV = { g7: 'Dexcom G7', libre3: 'FreeStyle Libre 3', omnipod: 'Omnipod' };
  var KEY = 'spare-skin-pick';

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  /* ---------- waitlist forms ---------- */
  function syncTags(wrap) {
    var tags = wrap.querySelector('[data-ssk-tags]');
    if (!tags) return;
    var parts = ['newsletter', 'spare-skin-waitlist'];
    var shade = wrap.querySelector('[data-ssk-shade]');
    var device = wrap.querySelector('[data-ssk-device]');
    if (shade && shade.value) parts.push('skin-shade-' + shade.value.toLowerCase());
    if (device && device.value) parts.push('skin-device-' + device.value);
    (wrap.getAttribute('data-extra') || '').split(',').forEach(function (t) { t = t.trim(); if (t) parts.push(t); });
    tags.value = parts.join(', ');
  }
  function setWait(wrap, pick) {
    var shade = wrap.querySelector('[data-ssk-shade]');
    var device = wrap.querySelector('[data-ssk-device]');
    if (shade && pick.shade !== undefined) shade.value = pick.shade || '';
    if (device && pick.device !== undefined) device.value = pick.device || '';
    if (pick.extra !== undefined) wrap.setAttribute('data-extra', pick.extra || '');
    syncTags(wrap);
  }
  var waits = [].slice.call(document.querySelectorAll('[data-ssk-wait]'));
  waits.forEach(function (wrap) {
    var saved = load();
    setWait(wrap, { shade: saved.shade || '', device: saved.device || '', extra: saved.extra || '' });
    wrap.addEventListener('change', function (e) {
      if (e.target.matches('[data-ssk-shade]')) wrap.setAttribute('data-extra', '');
      syncTags(wrap);
      var s = wrap.querySelector('[data-ssk-shade]'), d = wrap.querySelector('[data-ssk-device]');
      save({ shade: s ? s.value : '', device: d ? d.value : '', extra: wrap.getAttribute('data-extra') || '' });
    });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ssk-pick-device], [data-ssk-pick-shade]');
    if (!a) return;
    var pick = {};
    if (a.hasAttribute('data-ssk-pick-device') && a.getAttribute('data-ssk-pick-device')) pick.device = a.getAttribute('data-ssk-pick-device');
    if (a.hasAttribute('data-ssk-pick-shade')) { pick.shade = a.getAttribute('data-ssk-pick-shade'); pick.extra = ''; }
    waits.forEach(function (w) { setWait(w, pick); });
    var target = document.getElementById('skin-waitlist');
    if (target) {
      setTimeout(function () { var em = target.querySelector('input[type="email"]'); if (em) em.focus({ preventScroll: true }); }, 400);
    }
  });

  /* ---------- finder ---------- */
  var root = document.querySelector('[data-ssk-finder]');
  if (!root) return;
  var st = { step: 1, depth: null, tone: null, device: null };
  var labels = ['', 'Step 1 of 3 · Depth', 'Step 2 of 3 · Undertone', 'Step 3 of 3 · Device', 'Your match'];
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };

  function mark(attr, val) {
    $$('[' + attr + ']').forEach(function (b) { b.setAttribute('aria-checked', String(b.getAttribute(attr) === String(val))); });
  }
  function picksFor() {
    var d = st.depth == null ? 2 : st.depth;
    var c = { code: (d + 1) + 'C', name: CN[d], hex: C[d] };
    var w = { code: (d + 1) + 'W', name: WN[d], hex: W[d] };
    if (st.tone === 'B') return { list: [{ code: 'BK', name: 'Blackout', hex: '#1E1F21' }], pair: false };
    if (st.tone === 'N' || st.tone === 'U') return { list: [c, w], pair: true };
    return { list: [st.tone === 'C' ? c : w], pair: false };
  }
  function renderResult(focus) {
    var p = picksFor();
    var dev = DEV[st.device] || 'your device';
    var one = p.list[0];
    $('[data-r-title]').textContent = st.tone === 'B' ? 'Blackout it is.' : (p.pair ? 'Try these two, keep the one that blends best.' : 'Your shade is ' + one.code + ' ' + one.name + '.');
    $('[data-r-note]').textContent = st.tone === 'B'
      ? 'Matte black. It doesn’t try to hide. It just looks like you meant it.'
      : (p.pair ? 'Neutral skin can go either way. Wear one of each for a day, then keep the winner.'
        : 'Looks a touch light or dark once it’s on? Go one depth up or down next time.');
    $('[data-r-name]').textContent = p.pair
      ? 'Two-shade try-on pair for ' + dev + ' · ' + p.list[0].code + ' + ' + p.list[1].code
      : 'Spare Skins for ' + dev + ' · ' + one.code + ' ' + one.name;
    var box = $('[data-r-picks]');
    box.innerHTML = '';
    p.list.forEach(function (x) {
      var el = document.createElement('div'); el.className = 'ssk-result__pick';
      var patch = document.createElement('div'); patch.className = 'ssk-result__patch'; patch.style.background = x.hex;
      patch.appendChild(document.createElement('span'));
      var t = document.createElement('span'); t.textContent = x.code + ' ' + x.name;
      el.appendChild(patch); el.appendChild(t); box.appendChild(el);
    });
    var pick = p.pair
      ? { shade: '', device: st.device || '', extra: 'skin-shade-' + p.list[0].code.toLowerCase() + ', skin-shade-' + p.list[1].code.toLowerCase() + ', skin-tryon-pair' }
      : { shade: one.code, device: st.device || '', extra: '' };
    pick.depth = st.depth; pick.tone = st.tone;
    save(pick);
    root.querySelectorAll('[data-ssk-wait]').forEach(function (w) { setWait(w, pick); });
  }
  function go(step, focus) {
    st.step = step;
    $$('[data-f-step]').forEach(function (s) { s.hidden = Number(s.getAttribute('data-f-step')) !== step; });
    $$('[data-f-bar]').forEach(function (b) { b.classList.toggle('is-on', Number(b.getAttribute('data-f-bar')) <= Math.min(step, 3)); });
    $('[data-f-label]').textContent = labels[step];
    $('[data-f-back]').hidden = step === 1;
    $('[data-f-home]').hidden = step !== 1;
    if (step === 4) renderResult();
    if (focus !== false) {
      var h = $('[data-f-step="' + step + '"] [tabindex="-1"]');
      if (h) h.focus({ preventScroll: true });
      var top = root.getBoundingClientRect().top + window.scrollY - 90;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || !root.contains(b)) return;
    if (b.hasAttribute('data-depth')) { st.depth = Number(b.getAttribute('data-depth')); if (st.tone === 'B') st.tone = null; mark('data-depth', st.depth); go(2); }
    else if (b.hasAttribute('data-tone')) { st.tone = b.getAttribute('data-tone'); mark('data-tone', st.tone); go(3); }
    else if (b.hasAttribute('data-blackout')) { st.tone = 'B'; mark('data-depth', -1); mark('data-tone', ''); go(3); }
    else if (b.hasAttribute('data-device')) { st.device = b.getAttribute('data-device'); mark('data-device', st.device); go(4); }
    else if (b.hasAttribute('data-f-back')) { go(st.step === 3 && st.tone === 'B' ? 1 : Math.max(1, st.step - 1)); }
    else if (b.hasAttribute('data-f-restart')) { st = { step: 1, depth: null, tone: null, device: null }; mark('data-depth', -1); mark('data-tone', ''); mark('data-device', ''); go(1); }
  });

  /* Back from a waitlist signup (Shopify adds customer_posted=true): reopen the saved result. */
  if (/[?&]customer_posted=true/.test(location.search)) {
    var s = load();
    if (s.device) { st.depth = s.depth == null ? null : s.depth; st.tone = s.tone || 'W'; st.device = s.device; go(4, false); }
  }
})();
